import { render, staticRenderFns } from "./AddHotsiteSlot.vue?vue&type=template&id=5dde84ec"
import script from "./AddHotsiteSlot.vue?vue&type=script&lang=js"
export * from "./AddHotsiteSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports